import { useCallback, Fragment } from 'react';
import { connect } from 'react-redux';
import { isEveryone, isSpecific, isPrivate
// @ts-expect-error migrate upstream
} from 'dashboard-lib/public/permission/assignment-mode';
import { AssetPermission } from 'dashboard-lib/public/permission/asset-permission';
// @ts-expect-error migrate upstream
import { selectDashboardPermissionConfigAsStateGranular } from 'dashboard-lib/public/permission/permission-selector';
import UIButton from 'UIComponents/button/UIButton';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import FormattedMessage from 'I18n/components/FormattedMessage';
// @ts-expect-error migrate upstream
import { track } from 'dashboard-ui-components/tracking/DashboardUITracker';
// @ts-expect-error migrate upstream
import { useRefCache } from 'dashboard-components/hooks/useRefCache';
// @ts-expect-error migrate upstream
import { useShowDialog } from 'reporting-action-components/dialog/ducks';
// @ts-expect-error migrate upstream
import { DASHBOARD_SET_PERMISSION } from 'dashboard-lib/public/action/reporting-action';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const {
  VIEW,
  EDIT
} = AssetPermission;
const GranularPermissionActionButton = props => {
  var _dashboardConfigs$, _dashboardConfigs$2;
  const {
    dashboardConfigs,
    DisabledMessage = () => null,
    disabled = false,
    dashboardId,
    dashboardOwnerId,
    dashboardName
  } = props;
  const assignmentMode = (_dashboardConfigs$ = dashboardConfigs[0]) === null || _dashboardConfigs$ === void 0 ? void 0 : _dashboardConfigs$.accessClassification;
  const permissionLevel = (_dashboardConfigs$2 = dashboardConfigs[0]) === null || _dashboardConfigs$2 === void 0 ? void 0 : _dashboardConfigs$2.permissionLevel;
  const trackedProperties = useRefCache({
    assignmentMode,
    permissionLevel,
    //TODO: update these params
    // teamCount: count(selectedTeamSet || []),
    // userCount: count(selectedUserSet || []),
    dashboardId
  });
  const showDialog = useShowDialog();
  const handleOpenDialogClick = useCallback(() => {
    track('clickEditAccess', trackedProperties); // TODO: change this tracking
    showDialog({
      dialogType: DASHBOARD_SET_PERMISSION,
      dialogProps: {
        dashboardId,
        dashboardName,
        dashboardOwnerId,
        eventTracker: track
      }
    });
  }, [dashboardId, dashboardName, dashboardOwnerId, showDialog, trackedProperties]);
  const specificButton = /*#__PURE__*/_jsx(UITooltip, {
    disabled: !disabled,
    title: DisabledMessage && /*#__PURE__*/_jsx(DisabledMessage, {}),
    placement: "bottom",
    children: /*#__PURE__*/_jsx("strong", {
      children: /*#__PURE__*/_jsx(UIButton, {
        className: "m-left-2",
        use: "link",
        onClick: handleOpenDialogClick,
        disabled: disabled,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: 'dashboard.action.permission.label.SPECIFIC'
        })
      })
    })
  });
  const nonSpecificButton = /*#__PURE__*/_jsx(UITooltip, {
    disabled: !disabled,
    title: DisabledMessage && /*#__PURE__*/_jsx(DisabledMessage, {}),
    placement: "bottom",
    children: /*#__PURE__*/_jsx(UIButton, {
      use: "link",
      onClick: handleOpenDialogClick,
      disabled: disabled,
      children: /*#__PURE__*/_jsxs("strong", {
        children: [isEveryone(assignmentMode) && permissionLevel === EDIT && /*#__PURE__*/_jsx(FormattedMessage, {
          message: 'dashboard.action.permission.label.EVERYONE_EDIT'
        }), isEveryone(assignmentMode) && permissionLevel === VIEW && /*#__PURE__*/_jsx(FormattedMessage, {
          message: 'dashboard.action.permission.label.EVERYONE_VIEW'
        }), isPrivate(assignmentMode) && /*#__PURE__*/_jsx(FormattedMessage, {
          message: 'dashboard.action.permission.label.SUPERADMIN_OWNER'
        })]
      })
    })
  });
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [!isSpecific(assignmentMode) && nonSpecificButton, isSpecific(assignmentMode) && specificButton]
  });
};
export default connect(state => {
  const dashboardConfig = selectDashboardPermissionConfigAsStateGranular(state);
  return {
    dashboardConfigs: dashboardConfig || []
  };
})(GranularPermissionActionButton);